import request from './network';

const prefix = 'lz-member-server';

export const getPageComponentConfigListApi = (data: any) => {
  return request({
    url: `${prefix}/royalcanin/admin/page/component/config/list`,
    method: 'POST',
    data,
  });
};

export const editPageComponentConfigApi = (data: any) => {
  return request({
    url: `${prefix}/royalcanin/admin/page/component/config/edit`,
    method: 'POST',
    data,
  });
};
